import * as THREE from 'three';


//立体
export function genBoxGeometry(){
    const boxGeometry = new THREE.BoxGeometry(1, 1);
    const material = new THREE.MeshBasicMaterial({ color: 0x0ff000});
    const mesh = new THREE.Mesh(boxGeometry,material);
    mesh.position.x = 1.0;
    mesh.position.y = -1.5;
    return mesh;
}

export function genCapsuleGeometry(){
    const capsuleGeometry = new THREE.CapsuleGeometry(0.5, 0.5);
    const material = new THREE.MeshBasicMaterial({ color: 0x0ff000});
    const mesh = new THREE.Mesh(capsuleGeometry,material);
    mesh.position.x = 1.0;
    mesh.position.y = 0.0;
    return mesh;
}
//锥体
export function genConeGeometry(){
    const coneGeometry = new THREE.ConeGeometry(0.5, 0.5);
    const material = new THREE.MeshBasicMaterial({ color: 0x0ff000});
    const mesh = new THREE.Mesh(coneGeometry,material);
    mesh.position.x = 1.0;
    mesh.position.y = 1.5;
    return mesh;
}
//柱体
export function genCylinderGeometry(){
    const cylinderGeometry = new THREE.CylinderGeometry(0.5, 0.5);
    const material = new THREE.MeshBasicMaterial({ color: 0x0ff000});
    const mesh = new THREE.Mesh(cylinderGeometry,material);
    mesh.position.x = 2.5;
    mesh.position.y = -1.5;
    return mesh;
}
//十二面体
export function genDodecahedronGeometry(){
    const dodecahedronGeometry = new THREE.DodecahedronGeometry(0.5, 1);
    const material = new THREE.MeshBasicMaterial({ color: 0x0ff000});
    const mesh = new THREE.Mesh(dodecahedronGeometry,material);
    mesh.position.x = 2.5;
    mesh.position.y = 0.0;
    return mesh;
}
//球体
export function genSphereGeometry(){
    const sphereGeometry = new THREE.SphereGeometry(0.5, 10,10,5);
    const material = new THREE.MeshBasicMaterial({ color: 0x0ff000});
    const mesh = new THREE.Mesh(sphereGeometry,material);
    mesh.position.x = 4.0;
    mesh.position.y = 0.0;
    return mesh;
}

//拉伸管
export function genTubeGeometry(){
    const path = new THREE.CatmullRomCurve3([
        new THREE.Vector3( 0, 0, -3),   // 路径点1
        new THREE.Vector3( 3, 0, -3),    // 路径点2
        new THREE.Vector3( 3, 0,  3),     // 路径点3
        new THREE.Vector3(-3, 0,  3),    // 路径点4
        new THREE.Vector3(-3, 0, -3),     // 路径点5
        new THREE.Vector3(-1, 0, -3),   // 路径点1
    ]);
  
  // 2. 创建 TubeGeometry
  const tubeGeometry = new THREE.TubeGeometry(
    path,               // 中心路径（必须是 Curve 实例）
    160,                 // 管状分段数（tubularSegments）：路径方向的分段数，值越大越圆滑
    0.1,                  // 管体半径（radius）：垂直于路径的半径
    2,                 // 横截面分段数（radialSegments）：横截面的分段数，值越大越接近圆形
    true               // 是否闭合（closed）：路径首尾是否连接，默认 false
  );
  
  // 3. 创建材质和网格并添加到场景
  const material = new THREE.MeshBasicMaterial({ color: 0x00ff00, wireframe: false });
  const tubeMesh = new THREE.Mesh(tubeGeometry, material);

  return tubeMesh;
}

//面体
export function genPlaneGeometry(){
    const planeGeometry = new THREE.PlaneGeometry(1, 1);
    const material = new THREE.MeshBasicMaterial({ color: 0xff0000, side: THREE.DoubleSide});
    const plane = new THREE.Mesh(planeGeometry, material);
    plane.position.x = -1.0;
    return plane;
}
export function genCircleGeometry(){
    const circleGeometry = new THREE.CircleGeometry(0.7, 0.7);
    const material = new THREE.MeshBasicMaterial({ color: 0xff0000, side: THREE.DoubleSide});
    const plane = new THREE.Mesh(circleGeometry, material);
    plane.position.x = -1.0;
    plane.position.y = -1.5;
    return plane;
}


//线条
export function genEdgesGeometry(_scene){
    const boxGeometry = new THREE.BoxGeometry(1, 1);
    const material = new THREE.MeshBasicMaterial({ color: 0x0ff000});
    const mesh = new THREE.Mesh(boxGeometry,material);
    mesh.position.x = 2.5;
    mesh.position.y = 1.5;
    _scene.add(mesh);
    const edgesGeometry = new THREE.EdgesGeometry(boxGeometry);
    const dashedMaterial = new THREE.LineDashedMaterial({
        color: 0xff0000,
        linewidth: 1,
        dashSize: 0.1, // 破折号的长度
        gapSize: 0.05, // 破折号之间的间隙长度
    });
    const cubeEdges = new THREE.LineSegments(edgesGeometry, dashedMaterial);
    //关键步骤，只有这一步虚线才能展示出来
    cubeEdges.computeLineDistances(); 
    cubeEdges.position.x = 2.5;
    cubeEdges.position.y = 1.5;
    _scene.add(cubeEdges);
}


//ExtrudeGeometry
//IcosahedronGeometry
//LatheGeometry
//OctahedronGeometry
//PolyhedronGeometry
//RingGeometry
//ShapeGeometry
//TetrahedronGeometry
//TorusGeometry
//TorusKnotGeometry
//TubeGeometry
//WireframeGeometry

